import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { DisciplineState } from "@reducers/types/HRM/discipline-state";

import {
  createDisciplineRequest,
  getDisciplineRequest,
  deleteDisciplineRequest,
  updateDisciplineRequest,
} from "@actions/HRM/employee/discipline-actions";
import { getDisciplineState } from "@selectors/HRM/employee/discipline-selector";

import { useAppSelector } from "@helpers/redux";
import { DisciplineType, UpdateDisciplineType } from "@type/HRM/discipline";

interface UseDiscipline {
  getDisciplineRequestOngoing: boolean;
  getDisciplineSuccess: boolean;
  getDisciplineFailed: boolean;
  deleteDisciplineRequestOngoing: boolean;
  deleteDisciplineSuccess: boolean;
  deleteDisciplineFailed: boolean;
  createDisciplineRequestOngoing: boolean;
  createDisciplineSuccess: boolean;
  createDisciplineFailed: boolean;
  updateDisciplineRequestOngoing: boolean;
  updateDisciplineSuccess: boolean;
  updateDisciplineFailed: boolean;
  disciplines: DisciplineType[];
  createDiscipline: (data: DisciplineType) => void;
  updateDiscipline: (data: UpdateDisciplineType) => void;
  deleteDisciplineTable: (disciplineID: number) => void;
  handleQuery: () => void;
}

export const useDiscipline = (id: number | null): UseDiscipline => {
  const dispatch = useDispatch();
  const {
    data,
    getDisciplineRequestOngoing,
    getDisciplineSuccess,
    getDisciplineFailed,
    deleteDisciplineRequestOngoing,
    deleteDisciplineSuccess,
    deleteDisciplineFailed,
    createDisciplineRequestOngoing,
    createDisciplineSuccess,
    createDisciplineFailed,
    updateDisciplineRequestOngoing,
    updateDisciplineSuccess,
    updateDisciplineFailed,
  } = useAppSelector<DisciplineState>(getDisciplineState);

  const disciplines = data || [];

  useEffect(() => {
    id && dispatch(getDisciplineRequest(id));
  }, [dispatch, id]);

  const createDiscipline = (data: DisciplineType) =>
    dispatch(
      createDisciplineRequest({
        ...data,
        employeeID: id,
      }),
    );

  const updateDiscipline = (data: UpdateDisciplineType) =>
    dispatch(
      updateDisciplineRequest({
        ...data,
        employeeID: id,
      }),
    );

  const deleteDisciplineTable = (disciplineID: number) => {
    dispatch(
      deleteDisciplineRequest({
        employeeID: id,
        disciplineID,
      }),
    );
  };

  const handleQuery = () => {
    dispatch(getDisciplineRequest(id));
  };

  return {
    disciplines,
    createDiscipline,
    updateDiscipline,
    createDisciplineFailed,
    createDisciplineRequestOngoing,
    createDisciplineSuccess,
    deleteDisciplineFailed,
    deleteDisciplineRequestOngoing,
    deleteDisciplineSuccess,
    deleteDisciplineTable,
    getDisciplineFailed,
    getDisciplineRequestOngoing,
    getDisciplineSuccess,
    updateDisciplineRequestOngoing,
    updateDisciplineSuccess,
    updateDisciplineFailed,
    handleQuery,
  };
};
